<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">video_library</mat-icon>
    <span class="section-title">{{ 'general.youtubeTerms' | transloco }}</span>
    <button mat-icon-button class="ss-dialog-close-btn" (click)="closeDiag()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content style="padding-left: 50px; padding-right: 50px">
    <h4 style="font-size: 1.4em">TERMS OF USE REGARDING YOUTUBE COMPONENT</h4>

    <p>The Website utilizes YouTube API Services to enable users of the site to retrieve and share video content. When users access or utilize YouTube API Services, they must adhere to the YouTube API Services – Developer Policy. It's important to note that The Website does not employ YouTube API Services for data collection, external sharing or serving third-party advertisements to individual users, including the use of Google or YouTube end user credentials. The Website's use of the YouTube APIs is governed by its Privacy Policy. Whether users are individuals or part of an organization, their use or access of YouTube, regardless of whether it's through YouTube API Services or other means, is regulated by <a href="https://www.youtube.com/t/terms">YouTube's Terms of Service</a> and <a href="http://www.google.com/policies/privacy">Google Privacy Policy.</a></p>
    <br/>
    <br/>
    <p>do you agree to these terms?</p>
    <br/>
    <br/>
    <button (click)="agree()" style="margin: 5px" color="warn" mat-raised-button>YES</button>
    <button (click)="closeDiag()" style="margin: 5px" mat-raised-button color="primary">NO</button>
</div>
